import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCenterIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 15 15",
	style: { enableBackground: "new 0 0 15 15" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	    .center-icon-st0{fill:currentColor;}\n    "
	}), /* @__PURE__ */ _jsx("path", {
		className: "center-icon-st0",
		d: "M 5.1780862 1.4277034 C 4.4905869 1.4277034 3.9277035 1.9905868 3.9277035 2.6780861 L 3.9277035 4.1654794 L 5.1780862 4.1654794 L 5.1780862 2.6780861 L 6.6639602 2.6780861 L 6.6639602 1.4277034 L 5.1780862 1.4277034 z M 11.186912 1.4277034 L 11.186912 2.6780861 L 12.677344 2.6780861 L 12.677344 4.1654794 L 13.927727 4.1654794 L 13.927727 2.6780861 C 13.927727 1.9905868 13.364843 1.4277034 12.677344 1.4277034 L 11.186912 1.4277034 z M 8.3032833 3.3025179 L 8.3032833 5.8032833 L 5.8025179 5.8032833 L 5.8025179 7.0521467 L 8.3032833 7.0521467 L 8.3032833 9.5529121 L 9.5521467 9.5529121 L 9.5521467 7.0521467 L 12.052912 7.0521467 L 12.052912 5.8032833 L 9.5521467 5.8032833 L 9.5521467 3.3025179 L 8.3032833 3.3025179 z M 3.9277035 8.6899506 L 3.9277035 10.177344 C 3.9277035 10.864843 4.4905869 11.427727 5.1780862 11.427727 L 6.6654795 11.427727 L 6.6654795 10.177344 L 5.1780862 10.177344 L 5.1780862 8.6899506 L 3.9277035 8.6899506 z M 12.677344 8.6899506 L 12.677344 10.177344 L 11.189951 10.177344 L 11.189951 11.427727 L 12.677344 11.427727 C 13.364843 11.427727 13.927727 10.864843 13.927727 10.177344 L 13.927727 8.6899506 L 12.677344 8.6899506 z ",
		transform: "matrix(1.2855439,0,0,1.2855439,-3.9769696,-0.76310981)"
	})]
});
export default SvgCenterIcon;
